module.exports = __webpack_public_path__ + "img/2_1.e244eb31.png";